//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import config from '@/config';
import { getValue } from '@/components/diff/diff';
export default {
  data() {
    return {
      loading: false,
      list: [],
    };
  },
  created() {
    const { env, tag, tenant_id } = this.$route.query;
    if (!env || !tag || !tenant_id) {
      this.$router.replace({
        name: 'versions',
      });
    }
    this.getDetail(env, tag, tenant_id);
  },
  methods: {
    getValue(val) {
      return getValue(val);
    },
    async getDetail(env, tag, tenant_id) {
      this.$request({
        url: this.$api.metaGetMetadataByTag,
        data: {
          env,
          tag,
          tenant_id: ['development'].includes(config.env) ? tenant_id : undefined,
        },
        cb: ({ list }) => {
          this.list = list.map((item, index) => {
            const children = [];
            // 对象
            children.push({
              label: 'object',
              children: [item.object],
            });
            // 字段
            if (item.fields.length) {
              children.push({
                label: 'fields',
                children: item.fields,
              });
            }
            // 索引
            if (item.indexes.length) {
              children.push({
                label: 'indexes',
                children: item.indexes,
              });
            }

            return {
              label: index + 1,
              children,
            };
          });
        },
      });
    },
  },
};
